import { ProductActions, ProductActionTypes } from "../actions/product.action";

export interface ProductState {
  products: any[];
  productsLoading: boolean;
  productsError: boolean;
  
  productList: any[];
  productListLoading: boolean;
  productListError: boolean;

  productConfigurations: any[];
  productConfigurationsLoading: boolean;
  productConfigurationsError: boolean;

  createProductConfigurationSuccess: boolean;
  createProductConfigurationLoading: boolean;
  createProductConfigurationError: boolean;
  createdProductConfigurations: any[];

  updateProductConfigurationSuccess: boolean;
  updateProductConfigurationLoading: boolean;
  updateProductConfigurationError: boolean;
}

export const initialState: ProductState = {
  products: [],
  productsLoading: false,
  productsError: false,
  
  productList: [],
  productListLoading: false,
  productListError: false,

  productConfigurations: [],
  productConfigurationsLoading: false,
  productConfigurationsError: false,

  createProductConfigurationSuccess: false,
  createProductConfigurationLoading: false,
  createProductConfigurationError: false,
  createdProductConfigurations: [],

  updateProductConfigurationLoading: false,
  updateProductConfigurationError: false,
  updateProductConfigurationSuccess: false,
};

export function reducer(
  state = initialState,
  action: ProductActions
): ProductState {
  switch (action.type) {
    case ProductActionTypes.GET_PRODUCT_LIST: {
      return {
        ...state,
        productsLoading: true,
        productsError: false,
      };
    }

    case ProductActionTypes.GET_PRODUCT_LIST_SUCCESS: {
      return {
        ...state,
        products: action.payload,
        productsLoading: false,
        productsError: false,
      };
    }

    case ProductActionTypes.GET_PRODUCT_LIST_FAILURE: {
      return {
        ...state,
        productsLoading: false,
        productsError: true,
      };
    }
    
    case ProductActionTypes.GET_PAGED_PRODUCT_LIST: {
      return {
        ...state,
        productListLoading: true,
        productListError: false,
      };
    }

    case ProductActionTypes.GET_PAGED_PRODUCT_LIST_SUCCESS: {
      return {
        ...state,
        productList: action.payload,
        productListLoading: false,
        productListError: false,
      };
    }

    case ProductActionTypes.GET_PAGED_PRODUCT_LIST_FAILURE: {
      return {
        ...state,
        productListLoading: false,
        productListError: true,
      };
    }

    case ProductActionTypes.CLEAR_PRODUCT_LIST: {
      return {
        ...state,
        products: [],
        productList: []
      };
    }

    case ProductActionTypes.GET_PRODUCT_CONFIGURATION: {
      return {
        ...state,
        productConfigurationsLoading: true,
        productConfigurationsError: false,
      };
    }

    case ProductActionTypes.GET_PRODUCT_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        productConfigurations: action.payload,
        productConfigurationsLoading: false,
        productConfigurationsError: false,
      };
    }

    case ProductActionTypes.GET_PRODUCT_CONFIGURATION_FAILURE: {
      return {
        ...state,
        productConfigurationsLoading: false,
        productConfigurationsError: true,
      };
    }

    case ProductActionTypes.CREATE_PRODUCT_CONFIGURATION: {
      return {
        ...state,
        createProductConfigurationLoading: true,
        createProductConfigurationError: false,
      };
    }

    case ProductActionTypes.CREATE_PRODUCT_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        createdProductConfigurations: [...state.createdProductConfigurations, action.payload],
        createProductConfigurationSuccess: true,
        createProductConfigurationLoading: false,
        createProductConfigurationError: false,
      };
    }

    case ProductActionTypes.CREATE_PRODUCT_CONFIGURATION_FAILURE: {
      return {
        ...state,
        createProductConfigurationLoading: false,
        createProductConfigurationError: true,
      };
    }

    case ProductActionTypes.CLEAR_PRODUCT_CONFIGURATION: {
      return {
        ...state,
        createdProductConfigurations: [],
        createProductConfigurationSuccess: false,
        createProductConfigurationLoading: false,
        createProductConfigurationError: false,
      };
    }

    case ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION: {
      return {
        ...state,
        updateProductConfigurationLoading: true,
        updateProductConfigurationError: false,
      };
    }

    case ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        updateProductConfigurationSuccess: true,
        updateProductConfigurationLoading: false,
        updateProductConfigurationError: false,
      };
    }

    case ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION_FAILURE: {
      return {
        ...state,
        updateProductConfigurationLoading: false,
        updateProductConfigurationError: true,
      };
    }

    case ProductActionTypes.CLEAR_UPDATE_PRODUCT_CONFIGURATION: {
      return {
        ...state,
        updateProductConfigurationSuccess: false,
        updateProductConfigurationLoading: false,
        updateProductConfigurationError: false,
      };
    }

    default:
      return state;
  }
}
